module.exports = __webpack_public_path__ + "static/media/camera.10ba15e7.svg";